'use strict';

var _ = require('lodash');
var CompFaresChartControlsBoardController = function CompFaresChartControlsBoardController($scope) {
  $scope.toggleSelection = function (item) {
    if (!item.selectable) {
      return;
    }
    item.selected = !item.selected;
    $scope.contextData.compFares.legendFilter = item.selected ? _.filter($scope.contextData.compFares.legendFilter, function (filterItem) {
      return filterItem !== item.id;
    }) : $scope.contextData.compFares.legendFilter = _.without(_.concat($scope.contextData.compFares.legendFilter, item.id), undefined);
  };
  $scope.$watch('contextData.compFares.filter.display', function (newValue, oldValue) {
    if (oldValue === 'timeWindowCompFares' && newValue !== 'timeWindowCompFares') {
      $scope.contextData.compFares.filter.matchType.fare = false;
      $scope.contextData.compFares.filter.matchType.time = false;
    }
  });
};
CompFaresChartControlsBoardController.$inject = ['$scope'];
module.exports = CompFaresChartControlsBoardController;